var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pre',{staticClass:"content-pre"},[_vm._v(_vm._s(_vm.decodeHtml(_vm.content)))])
}
var staticRenderFns = []

export { render, staticRenderFns }